import type { TenantRestaurant } from './TenantApp';

export function RestaurantAvatar({ r, className = 'size-12' }: { r: TenantRestaurant; className?: string }) {
  if (r.logoPath) return <img src={r.logoPath} alt={`Logotipo de ${r.name}`} className={`${className} rounded-2xl bg-white object-contain p-1 shadow-card`} />;
  const initials = r.name
    .split(/\s+/)
    .filter((w) => w.length > 2)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
  return (
    <span className={`${className} grid place-items-center rounded-2xl bg-[var(--brand)] font-display text-lg font-semibold text-[var(--brand-contrast)]`} aria-hidden>
      {initials || r.name[0]}
    </span>
  );
}
